import { memo, useEffect } from 'react';
import { useNavigate } from 'react-router';
import * as R from 'Router/routes';
import { Loader } from 'components';
import { useAffiliate } from 'hooks/webapi';
import useCalculator from 'hooks/calculator/useCalculator';

/** This page is responsible for handling clients that are coming from affiliates with a pre-filled application */
const ContinueAffiliate = memo(function ContinueAffiliateMemo() {
  const navigate = useNavigate();
  const { fetchAffiliateForm, removeAffiliateCookieData } = useAffiliate();
  const { handleAmountChange } = useCalculator();

  useEffect(() => {
    (async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        // Get the hashed api token to retrieve pre-filled application

        const apiToken = urlParams.get('apiToken');
        if (apiToken) {
          await fetchAffiliateForm(apiToken);

          removeAffiliateCookieData();
        }

        navigate(R.INTRO);
      } catch {
        // TODO: If this failed, show some error notification or error screen
      }
    })();
  }, [fetchAffiliateForm, handleAmountChange, navigate, removeAffiliateCookieData]);

  return <Loader />;
});

export default ContinueAffiliate;
